import { render, staticRenderFns } from "./TagsFiltros.vue?vue&type=template&id=104cdc24&"
import script from "./TagsFiltros.vue?vue&type=script&lang=js&"
export * from "./TagsFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports